export default "__VITE_ASSET__41428043__"